import { useContext, defineComponent, ref, useCssModule } from '@nuxtjs/composition-api';
import { ADFOX_FETCH_STATES } from '~/components/Adfox';
import { isLightHouse, parseAdfoxHTML } from '~/utils';
export default defineComponent({
    name: 'BoxAdfox',
    props: {
        box: {
            required: true,
            type: Object,
        },
    },
    setup() {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const context = useContext();
        /**
         * Root element
         */
        const rootEl = ref();
        /**
         * Banner element
         */
        const bannerEl = ref();
        /**
         * Adfox states
         */
        const currentStates = ref({ ...ADFOX_FETCH_STATES });
        /**
         * Article props generated with parsed HTML in adfox container
         */
        const adfoxArticle = ref();
        const isPartnerCard = ref(false);
        const isVideo = ref(false);
        const shouldRender = ref(!isLightHouse(context.$device.userAgent));
        /**
         * Adfox onComplete
         */
        function onComplete({ data = {}, state }) {
            currentStates.value = state;
            shouldRender.value = (!state.withError || !state.withStub) && state.isRendered;
            if (!shouldRender.value || !rootEl.value) {
                return;
            }
            const adfoxEl = rootEl.value.querySelector('[id^="adfox"]');
            if (!adfoxEl) {
                return;
            }
            // Parse HTMl in Adfox container
            adfoxArticle.value = parseAdfoxHTML(adfoxEl) || {};
            // Partner card
            isPartnerCard.value = Boolean(adfoxArticle.value?.title && adfoxArticle.value?.path);
            if (isPartnerCard.value) {
                return;
            }
            // Video
            isVideo.value = Boolean(data?.bundleName === 'banner.inpage');
            if (isVideo.value) {
                let videoEl = null;
                const elems = adfoxEl.querySelectorAll('*');
                for (const { shadowRoot } of Array.from(elems)) {
                    if (shadowRoot) {
                        videoEl = shadowRoot.querySelector('video');
                    }
                }
                if (!videoEl) {
                    return;
                }
                videoEl.addEventListener('ended', ended);
                function ended() {
                    shouldRender.value = false;
                    videoEl?.removeEventListener('ended', ended);
                }
                return;
            }
            if (bannerEl.value) {
                bannerEl.value.style.minHeight = 'auto';
                bannerEl.value.style.minHeight = bannerEl.value.clientHeight + 'px';
            }
        }
        return {
            adfoxArticle,
            bannerEl,
            css,
            currentStates,
            isPartnerCard,
            isVideo,
            onComplete,
            rootEl,
            shouldRender,
        };
    },
});
